// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3whGN","clinicsSelect":"TableHeading_clinicsSelect__mrJ6c"};